<template>
  <section>
     <span @click="showModalAddVersionDocument">
      <slot></slot>
    </span>    

    <b-modal v-model="modalAddVersionDocument" size="lg" centered no-fade>
      <div slot="modal-header" class="w-100">{{ $t('TEMPLATES.ADD_VERSION.TITLE') }}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEMPLATES.ADD_VERSION.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEMPLATES.ADD_VERSION.INPUT_VERSION') }}</label>
            <b-input
              v-model.number="addFormVersion"
              type="number"
              name="name"
              autofocus
              required
            ></b-input>
          </div>

          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEMPLATES.ADD_VERSION.INPUT_DOCUMENT') }}</label>
            <b-form-file
              accept=".xml"
              v-model="addFormDocument"
              :state="Boolean(addFormDocument)"
              :placeholder="placeHolder"
            ></b-form-file>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEMPLATES.ADD_VERSION.INPUT_PUBLISH')">
              <b-form-radio-group id="addFormPublish" v-model="addFormPublish" name="publish">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
        <b-button
          variant="primary"
          class="btn-fill"
          @click="addDocumentVersion"
        >{{ $t('TEMPLATES.ADD_VERSION.ADD')}}</b-button>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      details: this.item,
      modalLoading: false,
      modalAddVersionDocument: false,
      addFormVersion: this.item.documentVersion.version,
      addFormDocument: "",
      addFormPublish: 0,
      addFormPublic: 0
    };
  },
  methods: {
    getVersion: function() {
      let self = this;
      this.$http
        .get(process.env.VUE_APP_BACKEND + `/template/version/getnumber`, {
          params: {
            version: this.item.documentVersion.version
          }
        })
        .then(function(response) {
          self.addFormVersion = response.data.versionNumber;
        })
        .catch(function(error) {
          self.$noty.error(self.$t(error.response.data));
        });
    },
    hideModals: function() {
      this.modalAddVersionDocument = false;
      this.modalLoading = false;
    },
    showModalAddVersionDocument: function() {
      this.getVersion();
      this.modalAddVersionDocument = true;
    },
    addDocumentVersion: function() {
      let self = this;
      this.modalLoading = true;
      let formData = new FormData();
      formData.append("DocumentId", this.details.document.id);
      formData.append("Document", this.addFormDocument);
      formData.append("Version", this.addFormVersion);
      formData.append("Publish", this.addFormPublish);
      formData.append("TeamId", this.teamId);
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/template/version/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          self.hideModals();
          self.details.documentVersion = response.data.documentVersion;
          if (self.details.documentVersion.published === 0) {
            self.$noty.info(self.$t("TEMPLATES.ADD_VERSION.SUCCESS.CREATED_DRAFT"));            
          } else {
            self.$emit("updatedDocumentVersion", self.details.documentVersion);
            self.$noty.info(self.$t("TEMPLATES.ADD_VERSION.SUCCESS.CREATED_PUBLISH"));
          }
        })
        .catch(function(error) {          
          self.$noty.error(self.$t(error.response.data));
          self.modalLoading = false;
        });
    }
  },
  computed: {
    placeHolder() {
      return this.$t('TEMPLATES.ADD_VERSION.SELECT_DOCUMENT');
    },
    teamId() {
      return this.$store.getters["auth/teamId"];
    }
  },
  mounted: function() {
    this.getVersion();
  }
};
</script>
<style>
</style>